module.exports = __webpack_public_path__ + "img/receivedXF1.27fa9213.png";